export const formatDate = (dateString: string, includeTime: boolean = false) => {
  if (!dateString) {
    return ''
  }

  const format = (d: Date) => d.toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' })

  // Fast path (only for ISO-like strings to avoid ambiguous locale parsing)
  const isIsoLike = /^\d{4}-\d{2}-\d{2}(?:[T\s].*)?$/
  if (isIsoLike.test(dateString)) {
    const native = new Date(dateString)
    if (!isNaN(native.getTime())) {
      return includeTime
        ? native.toLocaleString('en-GB', {
            day: 'numeric',
            month: 'long',
            year: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric',
            hour12: true,
          })
        : format(native)
    }
  }

  // Fallback: parse delimited numeric formats
  const nums = (dateString.match(/\d+/g) || []).map(Number)
  if (nums.length < 3) {
    return 'Invalid Date'
  }

  let year = 0
  let month = 0
  let day = 0

  if (String(nums[0]).length === 4) {
    // yyyy-mm-dd or yyyy/mm/dd
    ;[year, month, day] = [nums[0], nums[1], nums[2]]
  } else if (String(nums[2]).length === 4) {
    // dd-mm-yyyy or mm-dd-yyyy
    year = nums[2]
    const a = nums[0]
    const b = nums[1]
    if (a > 12 && b <= 31) {
      day = a
      month = b
    } else if (b > 12 && a <= 12) {
      month = a
      day = b
    } else {
      // Ambiguous: default to dd-mm-yyyy
      day = a
      month = b
    }
  } else {
    return 'Invalid Date'
  }

  const parsed = new Date(year, month - 1, day)
  return includeTime
    ? parsed.toLocaleString('en-GB', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        hour12: true,
      })
    : format(parsed)
}

/** Format an ISO date string as DD/MM/YYYY. */
export const formatIsoDate = (isoDate: string): string => {
  if (!isoDate) {
    return ''
  }

  const date = new Date(isoDate)
  if (isNaN(date.getTime())) {
    return 'Invalid Date'
  }

  const dd = String(date.getUTCDate()).padStart(2, '0')
  const mm = String(date.getUTCMonth() + 1).padStart(2, '0')
  const yyyy = date.getUTCFullYear()
  return `${dd}/${mm}/${yyyy}`
}

export const formatDateShort = (dateString: string) => {
  // Currently formatDate returns the date in the format of "31 January 2025"
  // We want to return the date in the format of "31 Jan 25"
  if (!dateString) {
    return ''
  }

  const format = (d: Date) => {
    const day = String(d.getDate()).padStart(2, '0')
    const month = d.toLocaleDateString('en-GB', { month: 'short' })
    const year = d.getFullYear().toString().slice(-2)
    return `${day} ${month} ${year}`
  }

  // Fast path (only for ISO-like strings to avoid ambiguous locale parsing)
  const isIsoLike = /^\d{4}-\d{2}-\d{2}(?:[T\s].*)?$/
  if (isIsoLike.test(dateString)) {
    const native = new Date(dateString)
    if (!isNaN(native.getTime())) {
      return format(native)
    }
  }

  // Fallback: parse delimited numeric formats
  const nums = (dateString.match(/\d+/g) || []).map(Number)
  if (nums.length < 3) {
    return 'Invalid Date'
  }

  let year = 0
  let month = 0
  let day = 0

  if (String(nums[0]).length === 4) {
    // yyyy-mm-dd or yyyy/mm/dd
    ;[year, month, day] = [nums[0], nums[1], nums[2]]
  } else if (String(nums[2]).length === 4) {
    // dd-mm-yyyy or mm-dd-yyyy
    year = nums[2]
    const a = nums[0]
    const b = nums[1]
    if (a > 12 && b <= 31) {
      day = a
      month = b
    } else if (b > 12 && a <= 12) {
      month = a
      day = b
    } else {
      // Ambiguous: default to dd-mm-yyyy
      day = a
      month = b
    }
  } else {
    return 'Invalid Date'
  }

  const parsed = new Date(year, month - 1, day)
  return format(parsed)
}
